const getErrorString = v => {
  let s = ' is required';
  if (v.length > 2 && v[2]) {
    if (v[2][0] === '#')
      return v[2].slice(1);
    else
      return v[2] + s;
  }
  return v[0] + s;
};

const util = {
  validate: (validatorsList, model, formError) => {
    let validation = true;
    let firstElement = null;
    validatorsList.forEach((validator) => {
      if (!validator[1](model)) {
        if (formError) {
          formError(validator[0], getErrorString(validator));
        }
        if (firstElement === null) {
          firstElement = validator[0];
        }
        validation = false;
      }
    });

    if (firstElement !== null) {
      util.focus(firstElement);
    }
    return validation;
  },
  focus: elementName => {
    const element = document.getElementsByName(elementName);
    if (element.length > 0) {
      let location = element[0].getBoundingClientRect();

      const coordenates = {
        left: location.left + window.scrollX,
        top: location.top + window.scrollY
      };
      element[0].focus();

      window.scroll(coordenates.left, coordenates.top - 80);
    }
  }
};

export default util;
